import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { subscriptionPlan } from "@/services/api/cresivoxServer";

import { iSubscriptionPlanDTO,iSubscriptionPlanMessageResponse,REDUCER_NAME} from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addSubscriptionPlan = createAsyncThunk<
iGenericResponse<any | null> | null,
{data:iSubscriptionPlanDTO},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("addSubscriptionPlan"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({data}, {rejectWithValue}) => {
    try {
        const response = await subscriptionPlan.createSubscriptionPlan(data);
        if (response) {
            const {httpStatusCode, data, message} = response;

            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                orders: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

  export const getAllSubscriptionPlanList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
      rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("SubscriptionPlanList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
      try {
          const response = await subscriptionPlan.getAllSubscriptionPlan();
          if (response) {
              const {httpStatusCode, data, message} = response;

              switch (httpStatusCode) {
                  case httpStatusCodes.SUCCESS_OK: {
                      if (data && data.data) {
                          return {
                            data:{
                                httpStatusCode,
                              data: data.data,
                              message,
                            }
                              
                          };
                      } else {
                          return rejectWithValue({
                              httpStatusCode,
                              message,
                          });
                      }
                  }
                  default: {
                      return rejectWithValue({
                          httpStatusCode,
                          message,
                      });
                  }
              }
          } else {
              return rejectWithValue({
                  message: "No response received",
              });
          }
      } catch (error) {
          return rejectWithValue({
              message: "Something went wrong",
          });
      }
  },
);



export const updateSubscriptionPlan = createAsyncThunk<
iGenericResponse<any | null> | null,
{data:iSubscriptionPlanDTO,planId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateSubscriptionPlane"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({data,planId}, {rejectWithValue}) => {
    try {
        const response = await subscriptionPlan.updateSubscriptionPlan(planId,data);
        if (response) {
            const {httpStatusCode, data, message} = response;

            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                orders: data.data?.order,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

export const deleteSubscriptionPlan = createAsyncThunk<
iGenericResponse<any | null> | null,
{planId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteSubscriptionPlan"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({planId}, {rejectWithValue}) => {
    try {
        const response = await subscriptionPlan.deleteSubscriptionPlan(planId); // ✅ Ensure correct structure
        if (response) {
            const {httpStatusCode, data, message} = response;
            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);


export const getActivationStatus = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
      rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getActivationStatus"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
      try {
          const response = await subscriptionPlan.getActivationStatus();
          if (response) {
              const {httpStatusCode, data, message} = response;

              switch (httpStatusCode) {
                  case httpStatusCodes.SUCCESS_OK: {
                      if (data && data.data) {
                          return {
                            data:{
                                httpStatusCode,
                              data: data.data,
                              message,
                            }
                              
                          };
                      } else {
                          return rejectWithValue({
                              httpStatusCode,
                              message,
                          });
                      }
                  }
                  default: {
                      return rejectWithValue({
                          httpStatusCode,
                          message,
                      });
                  }
              }
          } else {
              return rejectWithValue({
                  message: "No response received",
              });
          }
      } catch (error) {
          return rejectWithValue({
              message: "Something went wrong",
          });
      }
  },
);

export const subscribePlan = createAsyncThunk<
iGenericResponse<any | null> | null,
{planId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("subscribePlan"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({planId}, {rejectWithValue}) => {
    try {
        const response = await subscriptionPlan.subscribePlan(planId); // ✅ Ensure correct structure
        if (response) {
            const {httpStatusCode, data, message} = response;
            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_CREATED: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

export const verifyPayment = createAsyncThunk<
iGenericResponse<any | null> | null,
{transactionId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("verifyPayment"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({transactionId}, {rejectWithValue}) => {
    try {
        const response = await subscriptionPlan.verifyPayment(transactionId); // ✅ Ensure correct structure
        if (response) {
            const {httpStatusCode, data, message} = response;
            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

export const getAllTransactionListOfSubscriber = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
      rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getAllTransactionListOfSubscriber"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
      try {
          const response = await subscriptionPlan.getAllTransactionListOfSubscriber();
          if (response) {
              const {httpStatusCode, data, message} = response;

              switch (httpStatusCode) {
                  case httpStatusCodes.SUCCESS_OK: {
                      if (data && data.data) {
                          return {
                            data:{
                                httpStatusCode,
                              data: data.data,
                              message,
                            }
                              
                          };
                      } else {
                          return rejectWithValue({
                              httpStatusCode,
                              message,
                          });
                      }
                  }
                  default: {
                      return rejectWithValue({
                          httpStatusCode,
                          message,
                      });
                  }
              }
          } else {
              return rejectWithValue({
                  message: "No response received",
              });
          }
      } catch (error) {
          return rejectWithValue({
              message: "Something went wrong",
          });
      }
  },
);

export const applyCouponOnPlan = createAsyncThunk<
iGenericResponse<any | null> | null,
{planId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("applyCouponOnPlan"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({planId}, {rejectWithValue}) => {
    try {
        const response = await subscriptionPlan.applyCouponForActivatePlan(planId); // ✅ Ensure correct structure
        if (response) {
            const {httpStatusCode, data, message} = response;
            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_CREATED: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);


export const verifyCouponCode = createAsyncThunk<
iGenericResponse<any | null> | null,
{refferalCode:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("verifyCouponCode"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({refferalCode}, {rejectWithValue}) => {
    try {
        const response = await subscriptionPlan.verifyReferalCode(refferalCode); // ✅ Ensure correct structure
        if (response) {
            const {httpStatusCode, data, message} = response;
            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);
